module.exports = require('./dist/browser');
